var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27.994,
    viewBox: "0 0 28 27.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10693",
    "data-name": "Group 10693",
    transform: "translate(11688.209 22659.533)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8678",
    "data-name": "Rectangle 8678",
    width: 28,
    height: 27.995,
    rx: 13.998,
    transform: "translate(-11688.209 -22659.533)",
    fill: "#f0d9db"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1537",
    "data-name": "Line 1537",
    y2: 12.957,
    transform: "translate(-11669.629 -22650.117) rotate(45)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1538",
    "data-name": "Line 1538",
    y2: 12.957,
    transform: "translate(-11669.627 -22640.957) rotate(135)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.b04d059ed25efc35c69fc2f82d53497c.svg";
export { ForwardRef as ReactComponent };